import { DatePicker } from "../ui";

/* eslint-disable no-unused-vars */
export const DateField = ({ currentPosition, formField, ...props }) => <DatePicker { ...props }/>;